import React, { Component } from 'react';
import MenuItem from 'material-ui/MenuItem';
import DropDownMenu from 'material-ui/DropDownMenu';
import '../css/City.css';

let dropDownStyle = {
  backgroundColor: 'black',
  height: '35px',
  minWidth: '170px',
  lineHeight: '35px',
  overflow: 'inherit',
  color: 'rgba(255, 255, 255, 0.87)',
  fill: 'blue',
};
let iconStyle = {
  height: '35px',
  top: '-7px',
  right: '-5px',
};
let listStyle = {
  // 'background-color': '#DB8D44',
  'min-width': '170px',
};

class City extends Component {
  render() {
    if (!this.props.city) return '';
    return (
      <div className="staticWidth">
        <div className="staticHeader">
          {this.props.city.title}, {this.props.city.state.abbreviation}
        </div>
        <div className="pt1 mb8 staticBody faded">{this.props.city.county}</div>

        <div className="cityDropDown">
          <DropDownMenu
            style={dropDownStyle}
            labelStyle={dropDownStyle}
            iconStyle={iconStyle}
            listStyle={listStyle}
            underlineStyle={{ display: 'none' }}
            value={0}
            onChange={this.downloadData}
            default={'Download'}
          >
            {this.state.downloads.map((s, i) => {
              return (
                <MenuItem
                  key={i}
                  target="_blank"
                  disabled={s.disabled || false}
                  href={s.value + this.props.city.id}
                  primaryText={s.title}
                  value={s.value}
                />
              );
            })}
          </DropDownMenu>
        </div>

        <div className="mt5 citiesHeader mb1">Methods</div>
        <div
          className=" pt1 mb8 staticBody faded"
          dangerouslySetInnerHTML={{ __html: this.props.city.body }}
        />
      </div>
    );
  }

  constructor(props) {
    console.log(props);
    super();

    this.state = {
      downloads: [
        {
          title: 'Download',
          value: 0,
          disabled: true,
        },
        {
          title: 'CSV',
          value:
            'https://custom-jywf.frb.io/api/v1/export?includeAll=true&format=csv&cityIds=',
        },
        // {
        //   title: 'XLSX',
        //   value:
        //     'https://custom-jywf.frb.io/api/v1/export?includeAll=true&format=xlsx&cityIds=',
        // },
      ],
    };
    console.log(this);
    this.downloadData = this.downloadData.bind(this);
    window.scroll(0, 0);
  }

  downloadData(event, key, value) {
    // window.location =
    //   '/api/v1/export?cityIds=' +
    //   this.props.city.id +
    //   '&includeAll=true&format=csv';
  }
  componentDidMount() {
    document.getElementsByClassName('container')[0].parentNode.scrollTop = 0;
  }

  componentWillReceiveProps(nextProps) {
    document.getElementsByClassName('container')[0].parentNode.scrollTop = 0;
  }
}

export default City;



// WEBPACK FOOTER //
// ./src/components/City.jsx